<div class="">

  <div class="master-form">
    <div class="" *ngIf="linkCode == 5408 ||  linkCode == 5204">
      <app-fast-search [appCodes]="[2005 , 2006 , 1080 ,1126,154]" [searchType]="_StockParms"
        (searchKeys)="onSearchClick($event)" [appearFastSearch]="false" ngDefaultControl>
      </app-fast-search>
    </div>
    <div class="" *ngIf="(linkCode == 5301 ||  linkCode == 5216|| linkCode == 6578 || linkCode == 6579)">
      <app-fast-search [appCodes]="[2005 , 2006 , 1080 ,1127,154]" [searchType]="_StockParms"
        (searchKeys)="onSearchClick($event)" [appearFastSearch]="false" ngDefaultControl>
      </app-fast-search>
    </div> 
  </div>

  <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"(onPage)="paginate($event)"[totalRecords]="totalRecords" 
    [value]="examinationSupply" [rows]="10" [lazy]="true" [paginator]="true" [pageLinks]="3" [rowsPerPageOptions]="[5,10,20,50,100]">

    <p-column field="serial" header="{{ 'CODE' | translate }}" [sortable]="true"></p-column>
    <p-column field="{{translate.currentLang == 'ar' ? 'storeNameAr' : 'storeNameEn'}}"
      header="{{ 'STORE' | translate }}" [sortable]="true"></p-column>
    <p-column field="{{translate.currentLang == 'ar' ? 'depNameAr' : 'depNameEn'}}"
      header="{{ 'DEPARTMENT' | translate }}" [sortable]="true"></p-column>
    <p-column header="{{ 'EXAMINATIONDATE' | translate }}">
      <ng-template pTemplate="options" let-row="rowData">
        <i>{{row['examinationDate'] | date:'dd/MM/yyyy'}}</i>
      </ng-template>
    </p-column>
    <p-column field="poOrderSupplierCode" header="{{ 'POORDERSUPPLIERCODE' | translate }}" [sortable]="true"></p-column>



    <p-column field="{{translate.currentLang == 'ar'? 'orderStatNameAr': 'orderStatNameEn'}}"
      header="{{ 'POORDERSTATUS'  | translate}}" [sortable]="true"></p-column>

    <p-column header="{{ 'STATUS' | translate }}">
      <ng-template pTemplate="options" let-row="rowData">
        <span *ngIf="row.approvalStatus ==1  || row.approvalStatus ==100"> {{'AGREE' | translate}} </span>
        <span *ngIf="row.approvalStatus ==3"> {{'DISAGREE' | translate}} </span>
        <span *ngIf="row.approvalStatus !=3 && row.approvalStatus !=1  && row.approvalStatus !=100">
          {{'APPROVALWAITING' | translate}} </span>

      </ng-template>
    </p-column>


    <p-column [hidden]="examminationFlag == 1" width="100" header="{{ 'ACTIONS' | translate }}"
      [style]="{'width': '10%'}">
      <ng-template pTemplate="options" let-row="rowData">
        <icon-action  (clicked)="onRowIconClick($event , row)" [rowData]="row"
          [appCodes]="row['approvalStatus']==100 || row['approvalStatus']==1?[ 403 ,1013,7043,7054]:[1013,7043]">
        </icon-action>
      </ng-template>
    </p-column>

    <p-column [hidden]="examminationFlag != 1" width="100" header="{{ 'ACTIONS' | translate }}"
      [style]="{'width': '10%'}">
      <ng-template pTemplate="options" let-row="rowData">
        <icon-action *ngIf="row.orderStatus ==1" (clicked)="onRowIconClick($event , row)" [rowData]="row"
          [appCodes]="row['approvalStatus']==100 || row['approvalStatus']==1?[404, 7043,7054]:[7043]"></icon-action>
      </ng-template>
    </p-column>

  </p-dataTable>



</div>


<!------------------------------ popup-->
<block-modal-container #content (close)="onpopupClose($event)">
  <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
</block-modal-container>
<!------------------------------ end popup ------------------------------------>